import React from 'react';

function Button({ text, handleClick, isDisabled }) {
  return (
    <div className='keno-bet-type-btn-block'>
      <button
        type='button'
        className={`keno-bet-type-btn ${isDisabled ? 'disabled' : ''}`}
        onClick={handleClick}
      >
        <span className='btn-type-txt'>{text}</span>
      </button>
    </div>
  );
}
export default Button;
